import classes from './HeroPortada.module.css';

export function HeroImageBackground() {
  return (
    <div className={classes.wrapper}>
      
  </div>
  );
}